import { createEmptyRun } from "../../../../utils/articleParagraphUtils";

export const createParagraphBlock = () => ({
  type: "paragraph",
  runs: [createEmptyRun()],
});

export const createImageBlock = (image) => ({
  type: "image",
  objectKey: image.objectKey,
  publicUrl: image.publicUrl,
  alt: image.fileName || image.alt || "",
});

export const createImageBlockFromUrl = (url, alt = "") => {
  const publicUrl = String(url ?? "").trim();
  return {
    type: "image",
    objectKey: publicUrl,
    publicUrl,
    alt: String(alt ?? "").trim(),
  };
};

export const moveBlock = (blocks, fromIndex, direction) => {
  const toIndex = direction === "up" ? fromIndex - 1 : fromIndex + 1;
  if (toIndex < 0 || toIndex >= blocks.length) {
    return blocks;
  }
  const next = [...blocks];
  const [item] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, item);
  return next;
};

export const removeBlock = (blocks, index) => blocks.filter((_, currentIndex) => currentIndex !== index);

export const updateBlock = (blocks, index, patch) =>
  blocks.map((block, currentIndex) => (currentIndex === index ? { ...block, ...patch } : block));
